module.exports = __webpack_public_path__ + "static/media/landing-slider-img-1.8df22bdc.jpg";